"use client"
import React from "react";
import PropTypes from "prop-types";
import LoadingAnimation from "@/components/shared/LoadingAnimation";

const ToastContent = ({ message, type, showActivity, onClose }) => {
  const alertClass = type => {
    var classes = {
      error: "alert-danger",
      alert: "alert-warning",
      notice: "alert-info",
      success: "alert-success"
    };
    return classes[type] || classes.success;
  };

  const alertIcon = type => {
    var icons = {
      error: "error",
      alert: "warning",
      success: "check_circle",
      notice: "info"
    };
    return icons[type] || icons.success;
  };

  const alertIconColor = type => {
    var color = {
      error: "#82120B",
      alert: "#EBDC14",
      success: "#397488",
      notice: "#1565C0"
    };
    return color[type] || color.success;
  };

  const alertClassName = `toast-content ${alertClass(message.type)}`;
  return (
    <div className={alertClassName}>
      <div>
        <span
          className="material-icons"
          style={{ color: alertIconColor(message.type) }}
        >
          {alertIcon(message.type)}
        </span>
        <p style={{ marginBottom: 0 }}>{message.text}</p>
        {message.link && (
          <a style={{ marginLeft: "0.25rem" }} href={message.link.value}>
            {message.link.label}
          </a>
        )}
        <div className="flex-grow" />
        <span
          style={{ cursor: "pointer" }}
          className="material-icons"
          onClick={onClose}
        >
          close
        </span>
      </div>
      {showActivity && (
        <div
          style={{ display: "flex", alignItems: "center", marginTop: "0.5rem" }}
        >
          <LoadingAnimation size="sm" />
        </div>
      )}
    </div>
  );
};

ToastContent.propTypes = {
  onClose: PropTypes.func,
  timeout: PropTypes.number,
  message: PropTypes.object.isRequired
};

ToastContent.defaultProps = {
  timeout: 3000
};
export default ToastContent;
